import { render, staticRenderFns } from "./CommonSettings.vue?vue&type=template&id=e2238860&"
import script from "./CommonSettings.vue?vue&type=script&lang=js&"
export * from "./CommonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports